import {
  parseToKyiv, 
  nowInKyiv, 
  isAfter,
} from "@/src/shared/utils/dateTime";
import {isNumber} from "lodash";

export const getShiftedMinMaxDate = (
  minShift = 0,
  maxShift = 0,
  minYearsShift = 0,
  maxYearsShift = 0,
  startDate?: string,
): { min: string; max: string } => {
  // Start with the specified date or the current Kyiv time
  const today = startDate
    ? parseToKyiv(startDate)
    : nowInKyiv();
  
  if (!today) {
    // Fallback to current time if parsing fails
    const now = nowInKyiv();
    return {
      min: now.toISO()!,
      max: now.toISO()!
    };
  }

  const calculateDate = (daysShift: number, yearsShift: number) => {
    let result = today.startOf('day');
    if (isNumber(yearsShift) && yearsShift !== 0) {
      result = result.plus({ years: yearsShift });
    }

    if (isNumber(daysShift) && daysShift !== 0) {
      result = result.plus({ days: daysShift });
    }
    
    return result;
  };

  const minDate = calculateDate(minShift, minYearsShift);
  const maxDate = calculateDate(maxShift, maxYearsShift);

  // If min date is after max date, swap them
  if (isAfter(minDate, maxDate)) {
    return {
      min: maxDate.toISO()!,
      max: minDate.toISO()!,
    };
  }

  return {
    min: minDate.toISO()!,
    max: maxDate.toISO()!,
  };
};
